const permonthTransactionAmount = [
  {
    value: '0',
    key: '0-5万美金'
  },
  {
    value: '1',
    key: '5万美金-10万美金'
  },
  {
    value: '2',
    key: '10万-50万美金'
  },
  {
    value: '3',
    key: '50万-100万美金'
  },
  {
    value: '4',
    key: '100万-500万美金'
  },
  {
    value: '5',
    key: '500万以上美金'
  },
  {
    value: '6',
    key: '大约不超过营业额的25%'
  }
]
export default permonthTransactionAmount
